import { SidebarSimpleIcon, CheckIcon } from '@phosphor-icons/react';
import { Button } from '~/components/ui/button';
import { isShowing, useCanvas } from './canvas-context';

/**
 * FRONT-2594 — the "Open beside the chat" control on a sketch / deck / document
 * card. Renders nothing outside a Canvas context (other surfaces, flag off), so
 * those cards stay byte-identical. When this item is already on show it reads
 * "Showing" instead.
 */
export function CanvasOpenButton({ itemKey }: { itemKey: string }) {
  const canvas = useCanvas();
  if (!canvas || !canvas.items.some((i) => i.key === itemKey)) return null;
  if (isShowing(canvas, itemKey)) {
    return (
      <span
        data-testid="canvas-open-beside"
        data-showing="true"
        className="inline-flex items-center gap-1 text-xs text-muted-foreground"
      >
        <CheckIcon size={12} aria-hidden />
        Showing
      </span>
    );
  }
  return (
    <Button
      type="button"
      size="xs"
      variant="outline"
      data-testid="canvas-open-beside"
      onClick={() => canvas.openItem(itemKey)}
      className="gap-1"
    >
      <SidebarSimpleIcon size={12} aria-hidden />
      Open beside the chat
    </Button>
  );
}
